import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { fetchCompanies, fetchEconomicGroups } from "../../../store/middleware";

function CompaniesFilter({ util }) {
  const { t } = useTranslation();
  const { economicGroups } = useSelector((state) => state.b2bCompaniesReducer);

  const filterStartDates = util.getListOfFilterStartDates();
  const filterEndDates = util.getListOfFilterEndDates();

  const [active, setActive] = useState("");
  const [registerDateTo, setRegisterDateTo] = useState("");
  const [economicGroupId, setEconomicGroupId] = useState("");
  const [responsibleName, setResponsibleName] = useState("");
  const [registerDateFrom, setRegisterDateFrom] = useState("");

  const dispatch = useDispatch();

  const statusOptions = [
    { label: "Select", value: "" },
    { label: "Active", value: true },
    { label: "Inactive", value: false },
  ];

  useEffect(() => {
    dispatch(fetchEconomicGroups());
    // eslint-disable-next-line
  }, []);

  const applyFilters = (e) => {
    e.preventDefault();
    const filter = {
      pageNumber: 1,
      pageSize: 999,
      socialName: responsibleName,
      fantasyName: responsibleName,
      documentNumber: "",
      economicGroupId: parseInt(economicGroupId),
      registerDateFrom: registerDateFrom,
      registerDateTo: registerDateTo,
      active: active,
    };

    dispatch(fetchCompanies(filter));
  };

  const clearFilters = () => {
    const filter = {
      pageNumber: 1,
      pageSize: 999,
      socialName: "",
      fantasyName: "",
      documentNumber: "",
      economicGroupId: "",
      registerDateFrom: "",
      registerDateTo: "",
      active: "",
    };

    setEconomicGroupId("");
    setResponsibleName("");
    setRegisterDateFrom("");
    setRegisterDateTo("");
    setActive("");

    dispatch(fetchCompanies(filter));
  };

  const handleChange = (e) => {
    const { name, value } = e.currentTarget;

    switch (name) {
      case "responsibleName":
        setResponsibleName(value);
        break;
      case "economicGroupId":
        setEconomicGroupId(value);
        break;
      case "registerDateFrom":
        setRegisterDateFrom(value);
        break;
      case "registerDateTo":
        setRegisterDateTo(value);
        break;
      case "active":
        setActive(value);
        break;

      default:
        break;
    }
  };

  return (
    <div className="bigBox">
      <h2>
        <i className="fa fa-filter" aria-hidden="true"></i>Filters
      </h2>
      <form onSubmit={applyFilters}>
        <div className="formulario">
          <div className="lineInput">
            <label>{t("COMPANY")}</label>
            <input placeholder="Company name" name="responsibleName" onChange={handleChange} value={responsibleName} />
          </div>

          <div className="lineInput">
            <label>{t("ECONOMIC_GROUP")}</label>
            <select name="economicGroupId" value={economicGroupId} onChange={handleChange}>
              <option value="0">Select</option>
              {economicGroups?.map((item) => {
                return (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="lineInput">
            <label>{t("PERIOD_START")}</label>
            <select name="registerDateFrom" value={registerDateFrom} onChange={handleChange}>
              <option value="">Select</option>
              {filterStartDates.map((item) => {
                return (
                  <option value={item.value} key={JSON.stringify(item.value)}>
                    {item.description}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="lineInput">
            <label>{t("PERIOD_END")}</label>
            <select name="registerDateTo" value={registerDateTo} onChange={handleChange}>
              <option value="">Select</option>
              {filterEndDates.map((item) => {
                return (
                  <option value={item.value} key={JSON.stringify(item)}>
                    {item.description}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="lineInput">
            <label>Status</label>
            <select name="active" value={active} onChange={handleChange}>
              {statusOptions.map((option) => {
                return (
                  <option value={option.value} key={option.label}>
                    {option.label}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <div className="filtersBottom">
          <div className="items tiny"></div>
          <div className="items large text-center">
            <div className="show-extras"></div>
          </div>
          <div
            className="items tiny buttons text-right"
            style={{ widows: "100%", display: "flex", justifyContent: "flex-end" }}
          >
            <button type="button" className="btn-clear-filter" onClick={clearFilters} style={{ padding: "0px 16px" }}>
              {t("CLEAR_FILTERS")}
            </button>
            <button type="submit" className="btn-filter" style={{ padding: "0px 16px" }}>
              {t("FILTER")}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default CompaniesFilter;
